"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
var ContentFeedTypeEnum;
(function (ContentFeedTypeEnum) {
    ContentFeedTypeEnum["MEDIA"] = "media";
    ContentFeedTypeEnum["EVENT"] = "event";
    ContentFeedTypeEnum["CLIP"] = "clip";
    ContentFeedTypeEnum["PHOTO_GALLERY"] = "photo_gallery";
})(ContentFeedTypeEnum = exports.ContentFeedTypeEnum || (exports.ContentFeedTypeEnum = {}));
exports.isContentSetPurchaseTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "ContentSetPurchaseTransactionDetails";
};
exports.isFileContentFeedDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "FileContentFeedDetails";
};
class WithContentFeedSearch extends DataProvider_1.default {
    searchContentFeed({ data }) {
        return this.query("contentFeedSearch", { data }, this.getPageableFragment("ContentFeed"));
    }
}
exports.WithContentFeedSearch = WithContentFeedSearch;
class ContentFeedProvider extends WithContentFeedSearch {
    get fragments() {
        return {
            ContentFeed: () => `
        ... on ContentFeed {
          ${this.getFragment("ContentSetFields")}
          user {
            ${this.getFragment("UserPublicData")}          
          }
          purchased
          files {
            ${this.getFragment("ContentFile")}
          }
          likes {
            ${this.getFragment("LikesStatistic")}
          }
          subscriptionLevelId
          pricePackageId
          details {
            __typename
            ${this.getFragment("ContentFeedDetails")}
          }          
        }
      `,
            TransactionDetails: () => `
        ... on ContentSetPurchaseTransactionDetails {
          providerId
          consumerId
          subjectId
          contentSet {
            ${this.getFragment("ContentSet")}
          }
          opponent {
            ${this.getFragment("UserPublicData")}
          }
        }
      `,
            ContentFeedDetails: () => `
        ... on FileContentFeedDetails {
          dummy
        }
      `,
        };
    }
    search({ data }) {
        return this.searchContentFeed({ data });
    }
    followingContentFeedSearch({ data, }) {
        return this.query("followingContentFeedSearch", { data }, this.getPageableFragment("ContentFeed"));
    }
    discoveryContentFeedSearch({ data, }) {
        return this.query("discoveryContentFeedSearch", { data }, this.getPageableFragment("ContentFeed"));
    }
}
exports.ContentFeedProvider = ContentFeedProvider;
//# sourceMappingURL=ContentFeedProvider.js.map